import * as React from 'react'
import { connect } from 'react-redux'
import { getArticlesForCategory, navigateToArticle } from '../../actions/answers'
import { Header } from './header'
import { Article } from './article'
import { MainMenu } from '../mainmenu/menu'
import { currentParamsSelector } from '../../selectors/navigation'
import { currentAnswersArticlesSelector, currentAnswersArticlesStatusSelector } from '../../selectors/articles'
import { Container } from '../container'
import { RootState } from '../../types/rootstate'

import '../../sass/answers/popularquestions.scss'
import { CategoryBreadcrumbs } from './breadcrumbs/category-breadcrumbs'

interface StateProps {
  params: any
  status: string
  articles: RootState['articles']['key']['articles']
}

interface DispatchProps {
  getArticlesForCategory: (userId: number, answersId: number, categoryId: number) => void
  navigateToArticle: (userId: number, answersId: number, articleId: number) => void
}

interface OwnProps {}

type ArticleListProps = StateProps & DispatchProps & OwnProps

function mapStateToProps(state: RootState): StateProps {
  return {
    params: currentParamsSelector(state),
    status: currentAnswersArticlesStatusSelector(state),
    articles: currentAnswersArticlesSelector(state)
  }
}

function mapDispatchToProps(dispatch): DispatchProps {
  return {
    getArticlesForCategory: (userId, answersId, categoryId) =>
      dispatch(getArticlesForCategory(userId, answersId, categoryId)),
    navigateToArticle: (userId, answersId, articleId) =>
      dispatch(navigateToArticle(userId, answersId, articleId))
  }
}

interface ArticleListState {}

class ArticleListComponent extends React.Component<ArticleListProps, ArticleListState> {

  componentWillMount() {
    this.props.getArticlesForCategory(
      this.props.params.userId,
      this.props.params.answersId,
      this.props.params.categoryId
    )
  }

  handleArticleClick = (id: number) => {
    this.props.navigateToArticle(
      this.props.params.userId,
      this.props.params.answersId,
      id
    )
  }

  render() {
    return (
      <Container name='answers'>
        <Header />
        <div className="answers-dynamic-frame">

          <div className="container answers-category">
            <div className="row">
              {this.props.status === 'fetching' &&
                <div className="loadingSpinner">
                  <div className="accentPrimaryButton imbox-loader">
                    <div></div>
                  </div>
                </div>}
              {this.props.status === 'failed' &&
                <div className="col-xs-12 center-block">
                  Failed...
                </div>}

              <CategoryBreadcrumbs
                userId={this.props.params.userId}
                answersId={this.props.params.answersId}
                categoryId={this.props.params.categoryId}
                categoryName={this.props.params.categoryName}
              />

              {this.props.status === 'success' && <div className="col-xs-12 center-block">
                <div className="answers-popular-items">
                  <ul className="list-group">
                    {this.props.articles.map(article =>
                      <Article
                        key={article.id}
                        article={article}
                        onClick={this.handleArticleClick}
                      />
                    )}
                  </ul>
                </div>
              </div>}
            </div>
          </div>
        </div>
      </Container>
    )
  }
}

const ArticleList = connect<StateProps, DispatchProps, OwnProps>(mapStateToProps, mapDispatchToProps)(ArticleListComponent)


export {
  ArticleList
}
